import { apiRequest } from './api'

export function listClients() {
  return apiRequest('/clients/list', {
    method: 'POST',
  })
}

export function createClient(payload) {
  return apiRequest('/clients/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateClient(payload) {
  return apiRequest('/clients/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteClient(clientId) {
  return apiRequest('/clients/delete', {
    method: 'POST',
    body: JSON.stringify({ clientId }),
  })
}
